module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-MediumItalic-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-MediumItalic-webfont.svg
// module id = 1639
// module chunks = 0